import { Card, CardContent } from "@/components/ui/card";
import { RaceForm, type Race } from "@/components/race-form";

interface RaceDetailsStepProps {
  races: Race[];
  onUpdateRaces: (races: Race[]) => void;
}

export function RaceDetailsStep({
  races,
  onUpdateRaces,
}: RaceDetailsStepProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="space-y-4">
          <h2 className="text-2xl font-bold font-spartan">Your races</h2>
          <p className="text-gray-500">
            Your races will be displayed as badges on your quarter zip. We'll
            show you a preview in the next step.
          </p>
          <RaceForm onAddRace={onUpdateRaces} races={races} />
        </div>
      </CardContent>
    </Card>
  );
}
